import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserCreators } from 'redux/modules/user';

function useUser() {
   const dispatch = useDispatch();
   const user = useSelector(state => state.user.userInfo);

   const getUserInfo = useCallback(() => {
      dispatch(UserCreators.getUserInfos());
   }, []);

   return {
      user,
      getUserInfo,
   };
}

export default useUser;
